import React from 'react';
import { User, CaretPosition } from './types';
import { toRelativePath } from '../../utils/videoImagePath';
import styles from './RichCommentInput.module.css';

interface UserSuggestionsProps {
  users: User[];
  selectedUserIndex: number;
  position: CaretPosition;
  onMouseDown: (e: React.MouseEvent) => void;
  onUserClick: (userName: string) => void;
  onMouseEnter: (index: number) => void;
}

/**
 * ユーザーサジェスト表示コンポーネント
 */
export const renderUserSuggestions = ({
  users,
  selectedUserIndex,
  position,
  onMouseDown,
  onUserClick,
  onMouseEnter
}: UserSuggestionsProps): React.ReactNode => {
  return (
    <div 
      className={styles['rich-comment-input__user-suggestions']}
      style={{
        top: `${position.top}px`,
        left: `${position.left}px`,
      }}
      onMouseDown={onMouseDown}
      data-testid="rich-comment-input__user-suggestions"
    >
      {users.map((user, index) => (
        <div
          key={user.id}
          className={`${styles['rich-comment-input__user-suggestion-item']} ${index === selectedUserIndex ? styles.selected : ''}`}
          onClick={() => onUserClick(user.name)}
          onMouseEnter={() => onMouseEnter(index)}
          data-testid={`rich-comment-input__user-suggestion-item-${index}`}
        >
          <img
            src={user.icon_path ? toRelativePath(user.icon_path) : '/asset/no_icon_user.png'}
            alt={user.name}
          />
          <span>{user.name}</span>
        </div>
      ))}
    </div>
  );
};

export default renderUserSuggestions; 